// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1sHnW","right":"Footer_right___6uup","buttons":"Footer_buttons__PtuKj"};